<template>
  <section>
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="deliverToLoads-search-section"
        id="deliverToLoads-search-section"
      >
        <el-form
          id="deliverToLoads-search-section-form"
          class="search-section-form"
          :model="searchForm"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.shipDateFrom')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleSearch"
                  v-model="searchForm.shipDateFrom"
                  format="MM/dd/yyyy"
                  type="date"
                  :clearable="false"
                  id="searchForm-shipDateFrom"
                  ref="filter-shipDateFrom"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.shipDateTo')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleSearch"
                  v-model="searchForm.shipDateTo"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  id="searchForm-shipDateTo"
                  ref="filter-shipDateTo"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.loadName')">
                 <el-input
                  v-model="searchForm.loadNumber"
                  v-alphanumeric-validation
                  maxlength="20"
                  clearable
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-loadNumber"
                  id="searchForm-loadNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.deliveryDateFrom')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleSearch"
                  v-model="searchForm.deliveryDateFrom"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  id="searchForm-deliveryDateFrom"
                  ref="filter-deliveryDateFrom"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.deliveryDateTo')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleSearch"
                  v-model="searchForm.deliveryDateTo"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  id="searchForm-deliveryDateTo"
                  ref="filter-deliveryDateTo"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.onlyInProgress')">
                <el-select
                  v-model="searchForm.inProgress"
                  id="searchForm-status"
                  ref="filter-status"
                  @change="handleSearch">
                  <el-option
                    v-for="option in statusOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" class="text-align-end">
              <el-tooltip
                :content="$t('common.search')"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <el-button
                  id="deliverToLoads-search-section-form-button"
                  class="button-action-default"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import { LOADS_DELIVER_TO_SEARCH } from '@/store/actions';

export default {
  name: 'DeliverToLoadsSearchSection',
  computed: {
    ...mapGetters(['loads'])
  },
  data() {
    return {
      activeCollapsibleName: ['deliverToLoads-search-section'],
      isOpen: ['deliverToLoads-search-section'],
      searchForm: {
        shipDateFrom: moment().add(-7, 'day').toDate(),
        shipDateTo: null,
        loadNumber: null,
        deliveryDateFrom: null,
        deliveryDateTo: null,
        inProgress: constants.STATUS_BOOLEAN.no.value,
      },
      statusOptions: [constants.STATUS_BOOLEAN.yes, constants.STATUS_BOOLEAN.no]
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch(LOADS_DELIVER_TO_SEARCH, this.searchForm);
    }
  },
  watch: {
    'searchForm.shipDateFrom': function updateShipTo(newVal) {
      const newFrom = moment(newVal);
      if (newFrom.isAfter(moment(this.searchForm.shipDateTo))) {
        this.searchForm.shipDateTo = newVal;
      }
    },
    'searchForm.shipDateTo': function updateShipFrom(newVal) {
      const newTo = moment(newVal);
      if (newTo.isBefore(moment(this.searchForm.shipDateFrom))) {
        this.searchForm.shipDateFrom = newVal;
      }
    },
    'searchForm.deliveryDateFrom': function updateDeliveryTo(newVal) {
      const newFrom = moment(newVal);
      if (newFrom.isAfter(moment(this.searchForm.deliveryDateTo))) {
        this.searchForm.deliveryDateTo = newVal;
      }
    },
    'searchForm.deliveryDateTo': function updateDeliveryFrom(newVal) {
      const newTo = moment(newVal);
      if (newTo.isBefore(moment(this.searchForm.deliveryDateFrom))) {
        this.searchForm.deliveryDateFrom = newVal;
      }
    }
  }
};
</script>
